import React from 'react';

import atmediaLogo from '@images/atmedia-logo.svg';
import Image from 'next/image';

import Box from '@ui/Box';
import Link from '@ui/link/Link';
import PageTitle from '@ui/PageTitle';
import P from '@ui/staticpage/P';
import Subtitle from '@ui/staticpage/Subtitle';

import AdBanner from '@components/AdBanner/AdBanner';

const ImpressumPage = () => {
    return (
        <Box sx={{ maxWidth: 920 }}>
            <PageTitle>Impresszum</PageTitle>

            <Subtitle>Üzemeltető</Subtitle>
            <P sx={{ fontWeight: 700 }}>atmedia Korlátolt Felelősségű Társaság</P>
            <P>
                Székhely: 1138 Budapest, Dunavirág utca 2-6. I. ép. II. emelet
                <br />
                Adószám: 11674199-2-44
                <br />
                Cégjegyzékszám: 01-09-929668
            </P>

            <Subtitle>Tárhelyszolgáltató</Subtitle>
            <P sx={{ fontWeight: 700 }}>Microsoft Ireland Operations Ltd</P>
            <P>Székhely: One Microsoft Place, South County Business Park, Leopardstown, Dublin 18, D18 P521, Ireland</P>
            <P>Adószám: IE8256796U</P>

            <Subtitle>Hirdetések</Subtitle>
            <P>Hirdetésekkel kapcsolatos kérdésekben kérjük, forduljon kollegáinkhoz:</P>
            <P>
                <Link href="mailto:onlinesales@atmedia.hu">onlinesales@atmedia.hu</Link>
            </P>
            <Box sx={{ mt: 4 }}>
                <Link href="https://atmedia.hu/rolunk/online%20ertekesites/23?page=online" target="_blank">
                    <Image src={atmediaLogo} width={301} height={100} alt="atmedia" />
                </Link>
            </Box>

            <Subtitle>Írjon nekünk!</Subtitle>
            <P>
                Ha az oldal működésével, tartalmaival kapcsolatos kérdése, észrevétele van, írjon nekünk az{' '}
                <Link href="mailto:info@atalon.hu">info@atalon.hu</Link> címre!
            </P>

            <AdBanner adId="podpad_fekvo_1" sx={{ mt: 6 }} />
        </Box>
    );
};

export default ImpressumPage;
